var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showDialog
    ? _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "940px",
            "content-class": "print-or-save-invoices-dialog",
            persistent: "",
          },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          [
            _c(
              "v-card",
              { staticClass: "print-or-save-dialog-container" },
              [
                _c("LfBlueTitleComponent", {
                  attrs: { title: _vm.titleDialog },
                }),
                _vm.showSpinner
                  ? _c("SpinnerLayerComponent", {
                      staticClass: "spinner-layer",
                      attrs: {
                        loadingText: _vm.$t(
                          "components.spinner.generating_document"
                        ),
                      },
                    })
                  : [
                      _c(
                        "v-card-text",
                        { staticClass: "wizard-container" },
                        [
                          _vm.currentStep === _vm.steps.selectInvoices
                            ? [
                                _c("InvoicesTemplateSelectorComponent", {
                                  attrs: { idEntityType: _vm.idEntityType },
                                  on: {
                                    templateSelectedInvoice:
                                      _vm.templateSelectedInvoice,
                                    closeDialog: _vm.closeDialog,
                                  },
                                }),
                              ]
                            : _vm._e(),
                          _vm.currentStep === _vm.steps.configureOptions
                            ? [
                                _c("InvoiceConfigurationComponent", {
                                  attrs: {
                                    idEntityType: _vm.idEntityType,
                                    selectedInvoicesLength:
                                      _vm.invoiceGenerate.length,
                                    disableConfiguration:
                                      _vm.disableConfiguration,
                                  },
                                  on: { configButtons: _vm.configButtons },
                                }),
                              ]
                            : _vm._e(),
                          _vm.currentStep === _vm.steps.generationProgress ||
                          _vm.currentStep === _vm.steps.finalizeProcess
                            ? [
                                _c("InvoicesProgressVisualizer", {
                                  attrs: { invoices: _vm.invoiceGenerate },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c("PrintOrSaveInvoicesDialogActionsComponent", {
                        attrs: {
                          currentStep: _vm.currentStep,
                          disabledNextButton: _vm.disabledNextButton,
                        },
                        on: { eventButton: _vm.actionsButtons },
                      }),
                    ],
              ],
              2
            ),
          ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }